import React from "react";

function Naviee(props) {
  return (
    <img height="263px" {...props} src="/media/naviee.png"/>
  );
}

export default Naviee;